// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__SUd6V","progressBar":"styles_progressBar__qBYby"};